import { render, staticRenderFns } from "./FooterCollege.vue?vue&type=template&id=03f76156&"
import script from "./FooterCollege.vue?vue&type=script&lang=js&"
export * from "./FooterCollege.vue?vue&type=script&lang=js&"
import style0 from "./FooterCollege.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports